import styled from "styled-components";

export const DetailInfo = styled.p`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const Name = styled.strong`
  min-width: 180px;
`;
